import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import langImage from '../../../static/group_image/lang-icon.png';
import { useLocale } from '../../../contexts/LocaleProvider';
import { ENABLED_LOCALES } from '../../../utils/Locale';
import Image from 'next/image';

interface LanguageSelectorProps {}

const LanguageSelector: FunctionComponent<LanguageSelectorProps> = () => {
    const { name: currentLocaleName, setLocale } = useLocale();
    const [languageMenuOpen, setLanguageMenuOpen] = useState<boolean>(false);

    const menuRef = useRef<HTMLDivElement>(null);

    const handleLocaleChange = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target as HTMLDivElement;
        const newLocale = target.getAttribute('data-value');
        if (newLocale) {
            setLocale(newLocale);
        }
        setLanguageMenuOpen(false);
    };

    const handleLangSelectClick = () => {
        setLanguageMenuOpen(!languageMenuOpen);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setLanguageMenuOpen(false);
        }
    };

    useEffect(() => {
        if (languageMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [languageMenuOpen]);

    return (
        <div ref={menuRef}>
            <div className="lang-select" onClick={handleLangSelectClick}>
                <Image className="lang-icon" src={langImage} alt="Language Icon" />
                <div className="lang-text">{currentLocaleName}</div>
            </div>
            {languageMenuOpen && (
                <div className="lang-menu">
                    {ENABLED_LOCALES.map((locale) => (
                        <div
                            className="lang-option"
                            data-value={locale.locale}
                            key={locale.locale}
                            onClick={handleLocaleChange}
                        >
                            {locale.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
